import { Component, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { RowDef } from '../../../shared/components/table/table.component';
import { CallbacksHistoryFilter } from '../../../shared/models/callback-history.model';
import { ModalService } from '../../../shared/services/modal.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { CallbackHistoryFilterComponent } from '../callback-history-filter/callback-history-filter.component';
import { CallbackHistoryTableComponent } from '../callback-history-table/callback-history-table.component';

@Component({
  standalone: false,
  selector: 'app-callback-history-index',
  templateUrl: 'callback-history-index.component.html',
})
export class CallbackHistoryIndexComponent {
  @ViewChild(CallbackHistoryFilterComponent, { static: false }) filter: CallbackHistoryFilterComponent;
  @ViewChild(CallbackHistoryTableComponent, { static: false }) table: CallbackHistoryTableComponent;

  backButtonShow = false;

  selectedRows: RowDef[] = [];
  batchCompleted = 0;
  progressShow = false;

  constructor(
    public route: ActivatedRoute,
    public notificationService: NotificationService,
    titleService: Title,
    public modal: ModalService
  ) {
    titleService.setTitle('Callback history');
  }

  onFilter(data) {
    const params: CallbacksHistoryFilter = {};
    if (data.service) {
      params.service = data.service;
    }
    this.table.filter = params;
    this.table.page = 1;
    this.table.update(true);
  }

  batchClear() {
    this.progressShow = false;
    this.selectedRows = [];
    this.table.resetBatch();
  }
}
